import React from 'react';
import DisplayMinutes from '../../../components/MatchTimelineTable/DisplayMinutes';
import { MATCH_STATUS } from '../../../constants';

class MatchTimelineCornersTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      homeGoalsMinutes: [],
      awayGoalsMinutes: [],
      homeCornersMinutes: [],
      awayCornersMinutes: [],
      goldenGoalsMins: [],

      renderHTResults: false,
    };
  }

  componentDidMount() {
    this.getEventsMinutes();
    this.shouldRenderHTDetails();
  }

  getMinutes = (specificEventType) => this.props.matchTimelineEvents
    .filter((event) => event.eventType === specificEventType);

  getEventsMinutes = () => {
    const homeGoalsMinutes = this.getMinutes(this.props.eventType.GOAL_HOME);
    const awayGoalsMinutes = this.getMinutes(this.props.eventType.GOAL_AWAY);
    const homeCornersMinutes = this.getMinutes(this.props.eventType.CORNER_HOME);
    const awayCornersMinutes = this.getMinutes(this.props.eventType.CORNER_AWAY);
    const goldenGoals = this.getMinutes(this.props.eventType.GOLDEN_GOAL);

    const goldenGoalsMins = goldenGoals?.length > 0
      ? goldenGoals.map((ggEvent) => ggEvent.matchMinute)
      : [];

    this.setState({
      homeGoalsMinutes,
      awayGoalsMinutes,
      homeCornersMinutes,
      awayCornersMinutes,
      goldenGoalsMins,
    });
  };

  shouldRenderHTDetails = () => {
    let renderHTResults = false;
    if (this.props.timeDetails === MATCH_STATUS.HT || this.props.timeDetails === MATCH_STATUS.FT) {
      renderHTResults = true;
    } else {
      const time = parseInt(this.props.timeDetails.split('\'')[0]);
      if (time > 45) renderHTResults = true;
    }
    this.setState({
      renderHTResults,
    });
  };

  showGoldenBall = (goals) => {
    if (goals?.length > 0 && this.state.goldenGoalsMins?.length > 0) {
      for (let i = 0; i < goals.length; i += 1) {
        if (this.state.goldenGoalsMins?.includes(goals[i]?.matchMinute)) {
          return true;
        }
      }
    }
    return false;
  };

  render() {
    const {
      awayCorners, awayCornersHT, awayScoreHT,
      homeCorners, homeCornersHT, homeScoreHT,
    } = this.props.eventDetails;

    return (
      <div className="timeline__row m-t-20">
        <div className="timeline__corner">
          <div className="timeline__corner-score">
            <div className="table-f timeline__corner-wrap">
              <div className="timeline__corner-home">
                <div>
                  <DisplayMinutes
                    minutes={this.state.homeGoalsMinutes}
                    goldenGoals={this.state.goldenGoalsMins}
                  />
                </div>
                <i className={`timeline__corner-icon ball right ${this.showGoldenBall(this.state.homeGoalsMinutes) ? 'is-golden' : ''}`} />
              </div>

              <div className="timeline__corner-score-txt">
                {this.state.renderHTResults
                  && (
                    <>
                      <div>{`${homeScoreHT}-${awayScoreHT}`}</div>
                      <div>HT</div>
                    </>
                  )}
              </div>
              <div className="timeline__corner-away">
                <div>
                  <DisplayMinutes
                    minutes={this.state.awayGoalsMinutes}
                    goldenGoals={this.state.goldenGoalsMins}
                  />
                </div>
                <i className={`timeline__corner-icon ball left ${this.showGoldenBall(this.state.awayGoalsMinutes) ? 'is-golden' : ''}`} />
              </div>
            </div>
          </div>
          <div className="table-f timeline__corner-title">
            <div className="timeline__corner-txt">{homeCorners}</div>
            <div className="timeline__corner-info">
              <span className="timeline__corner-description">CORNER</span>
            </div>
            <div className="timeline__corner-txt">{awayCorners}</div>
          </div>
          <div className="timeline__corner-sec">
            <div className="table-f timeline__corner-wrap">
              <div className="timeline__corner-home">
                <div>
                  <DisplayMinutes
                    minutes={this.state.homeCornersMinutes}
                  />
                </div>
                <i className="timeline__corner-icon flag right" />
              </div>
              <div className="timeline__corner-score-txt">
                {this.state.renderHTResults
                  && (
                    <>
                      <div>{`${homeCornersHT}-${awayCornersHT}`}</div>
                      <div>CORNER HT</div>
                    </>
                  )}
              </div>
              <div className="timeline__corner-away">
                <div>
                  <DisplayMinutes
                    minutes={this.state.awayCornersMinutes}
                  />
                </div>
                <i className="timeline__corner-icon flag left" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MatchTimelineCornersTable;
